import CampaignsService from './CampaignsService';

let instance;

export default function CampaignsServiceProvider() {
  if (!instance) {
    instance = new CampaignsService();
  }

  return instance;
}



// WEBPACK FOOTER //
// ./src/api/campaigns/CampaignsServiceProvider.js